// Licensed to All Seasons Landscaping (2025) – see LICENSE.txt
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ScrollToTop from './components/ScrollToTop'; 
import BackButton from './components/BackButton';
import Footer from './components/Footer';
import Home from './pages/Home';
import Snow from './pages/Snow';
import Special from './pages/Special';
import Premium from './pages/Premium';
import Maintenance from './pages/Maintenance';
import Careers from './pages/CareersPage';
import ApplyHere from './pages/ApplyHere';
import Team from './pages/TeamPage';
import TreeFarm from './pages/TreeFarm';
import Tree from './pages/Tree';
import Light from './pages/Light';
import BackToTheTop from './components/BackToTheTop'; 
import Fire from './pages/Fire';
import WaterFeature from './pages/WaterFeature';
import Flower from './pages/Flower';
import Hardscape from './pages/Hardscape';
import Landscape from './pages/Landscape';
import LandscapeConstruction from './pages/LandscapeConstruction';
import Fence from './pages/Fencing';
import Testimonial from './pages/Testimonial';
import EcoPage from './pages/EcoPage';
import Gallery from './pages/Gallery';
import Projects from './pages/Projects';
import GallerySection from './pages/GallerySection';
import ProjectSection from './pages/ProjectSection';
import ResidentialClientPage from './pages/ResidentialClientPage';
import PropertyManagementPage from './pages/PropertyManagementPage';
import TeamWork from './pages/TeamWork';
import Contact from './pages/Contact';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsConditions from './pages/TermsConditions';
import './styles/root.css';
import './styles/heroImageOptimization.css';


const App = () => {
  return (
    <Router>
    <ScrollToTop/>
     <BackButton />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/Snow" element={<Snow />} />
        <Route path="/Special" element={<Special/>} />
        <Route path="/EcoPage" element={<EcoPage/>} />
        <Route path="/Premium" element={<Premium/>} />
        <Route path="/Maintenance" element={<Maintenance/>} />
        <Route path="/TeamPage" element={<Team />} />
        <Route path="/CareersPage" element={<Careers/>} />
        <Route path="/ApplyHere" element={<ApplyHere />} />
        <Route path="/ResidentialClientPage" element={<ResidentialClientPage />} />
        <Route path="/PropertyManagementPage" element={<PropertyManagementPage/>} />
        <Route path="/Tree" element={<Tree/>} />
        <Route path="/TreeFarm" element={<TreeFarm/>} />
        <Route path="/light" element={<Light/>} />
        <Route path="/Fire" element={<Fire/>} />
        <Route path="/flower" element={<Flower/>} />
        <Route path="/WaterFeature" element={<WaterFeature/>} />
        <Route path="/fencing" element={<Fence/>} />
        <Route path="/hardscape" element={<Hardscape/>} />
        <Route path="/landscape" element={<Landscape/>} />
        <Route path="/LandscapeConstruction" element={<LandscapeConstruction/>} />
        <Route path="/Testimonial" element={<Testimonial/>} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/Projects" element={<Projects/>} />
        <Route path="/gallery/:sectionId" element={<GallerySection />} />
        <Route path="/projects/:sectionId" element={<ProjectSection />} />
        <Route path="/gallery/teamAction" element={<TeamWork />} />
        <Route path="/Contact" element={<Contact />} />
        <Route path="/PrivacyPolicy" element={<PrivacyPolicy />} />
        <Route path="/TermsConditions" element={<TermsConditions />} />
        <Route path="/" element={<Home />} />
      </Routes>
      <BackToTheTop/>
      <Footer/>
    </Router>
  );
};

export default App;

